export default [
    'creditAppDeals',
    'creditVerification',
    'creditType',
    'leaseTerm',
    'leaseMileageRange',
    'loanTerm',
    'downPayment',
    'downPaymentPercent',
    'interestRate',
    'budget',
    'dealType',
    'tradeIn',
    'monthlyBudget',
    'zip',
    'drDeals',
    'walletId',
];
